import { Text } from '@mxenabled/mxui'
import { GridColumnHeaderParams } from '@mui/x-data-grid'
import { Icon } from '@mxenabled/mx-icons'
import { Stack } from '@mui/material'

export const HeaderCell = (params: GridColumnHeaderParams) => (
  <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 4 }}>
    <Text sx={{ color: 'text.primary', fontWeight: 600, fontSize: 14 }} variant="body2">
      {params.colDef.headerName}
    </Text>
    <Icon name={'expand_all'} size={12} />
  </Stack>
)
